@use "src/sedestral/sass/icons/icons";

.componentCommunityPageBlogIcon {
  height: 100%;
  width: 100%;

  &.WEBFLOW {
    @include icons.ico("colored-webflow");
  }

  &.WORDPRESS {
    @include icons.ico("colored-wordpress");
  }

  &.SHOPIFY {
    @include icons.ico("colored-shopify");
  }

  &.PRESTASHOP {
    @include icons.ico("colored-prestashop");
  }

  &.JOOMLA {
    @include icons.ico("colored-joomla");
  }

  &.ODOO {
    @include icons.ico("colored-odoo");
  }

  &.STORYBLOK {
    @include icons.ico("colored-storyblok");
  }

  &.WIX {
    @include icons.ico("black-wix");
  }
}